type Fbq = (...args: unknown[]) => void;

export function trackInitiateCheckout() {
  const fbq = (window as unknown as { fbq?: Fbq }).fbq;
  fbq?.('track', 'InitiateCheckout');
}
